/* ============================================================
   IMENHOF BLOOM — mega-menu.js
   Desktop-megamenu: open op klik/hover, takken wisselen via de rail.
   A11y (audit juli 2026):
   • geen role=tab/aria-selected meer — gewone knoppen met aria-current
   • menu opent niet meer op toetsenbord-focus (alleen Enter/klik),
     zodat tabbende gebruikers er niet doorheen gedwongen worden
   • Escape sluit én zet de focus terug op de triggerknop
   ============================================================ */
(function () {
  'use strict';
  function init(scope) {
    var mm = scope.querySelector('[data-mm]'),
        panel = scope.querySelector('[data-mm-panel]');
    if (!mm || !panel || mm.dataset.mmReady) return;
    mm.dataset.mmReady = '1';
    var trigger = mm.querySelector('.mm-trigger'),
        tabs = [].slice.call(panel.querySelectorAll('.mm-tab')),
        panes = [].slice.call(panel.querySelectorAll('.mm-pane')),
        timer,
        focusTimer;
    function activate(id, moveFocus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-branch') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && moveFocus) t.focus();
      });
      panes.forEach(function (p) {
        var on = p.getAttribute('data-branch') === id;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    }
    function open(focusMenu) {
      clearTimeout(timer);
      // Een muis-enter kan direct na toetsenbord-openen volgen. Laat die
      // gebeurtenis de geplande toetsenbordfocus niet annuleren.
      if (focusMenu) clearTimeout(focusTimer);
      mm.classList.add('is-open');
      panel.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (focusMenu) {
        var active = panel.querySelector('.mm-tab.is-active') || tabs[0];
        if (active) {
          // Verplaats focus direct binnen de toetsgebeurtenis. De vertraagde
          // poging is een vangnet voor browsers die eerst de stijl bijwerken.
          active.focus();
          focusTimer = window.setTimeout(function () {
            if (panel.classList.contains('is-open') && document.activeElement === trigger) active.focus();
          }, 240);
        }
      }
    }
    function close() {
      clearTimeout(focusTimer);
      mm.classList.remove('is-open');
      panel.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    function schedule() { timer = setTimeout(close, 150); }
    tabs.forEach(function (t) {
      var go = function () { activate(t.getAttribute('data-branch'), false); };
      t.addEventListener('mouseenter', go);
      t.addEventListener('focus', go);
      t.addEventListener('click', go);
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t), next = -1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        e.preventDefault();
        activate(tabs[next].getAttribute('data-branch'), true);
      });
    });
    if (tabs[0]) activate(tabs[0].getAttribute('data-branch'), false);
    mm.addEventListener('mouseenter', function () { open(false); });
    mm.addEventListener('mouseleave', schedule);
    panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
    panel.addEventListener('mouseleave', schedule);
    if (trigger) trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.classList.contains('is-open')) close(); else open(false);
    });
    if (trigger) trigger.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      if ((e.key === 'Enter' || e.key === ' ') && panel.classList.contains('is-open')) close();
      else open(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !panel.classList.contains('is-open')) return;
      close();
      if (trigger) trigger.focus();
    });
    document.addEventListener('click', function (e) {
      if (!mm.contains(e.target) && !panel.contains(e.target)) close();
    });
    document.addEventListener('focusin', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (!mm.contains(e.target) && !panel.contains(e.target)) close();
    });
  }
  function boot() { document.querySelectorAll('[data-mm-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) init(e.target);
  });
})();
